import { useChecklist } from '@hooks/queries/useChecklist';
import { useCompany } from '@hooks/queries/useCompany';
import { useDelegation } from '@hooks/queries/useDelegation';
import { useUser } from '@hooks/queries/useUser';
import { MembershipFormFields } from '@models/MembershipForm';
import { makeMuiStyles } from '@styles';
import { isRight } from 'fp-ts/lib/Either';
import compact from 'lodash-es/compact';

export const useEnabledSteps = (): string[] => {
  const company = useCompany();
  const user = useUser();
  const checklist = useChecklist();
  const delegation = useDelegation();

  if (company.data && user.data && checklist.data && delegation.data) {
    const membershipFormValues = MembershipFormFields.shared.mapCompanyUserToMembershipForm(
      company.data!,
      user.data!,
    );

    const checklistFormValues = MembershipFormFields.shared.mapChecklistToChecklistForm(
      checklist.data!,
    );

    const membershipFormValid = isRight(
      MembershipFormFields.shared.toMembershipFormSchema().decode(membershipFormValues),
    );

    const checklistFormValid = isRight(
      MembershipFormFields.shared.toChecklistFormSchema().decode(checklistFormValues),
    );

    const delegationValid = delegation.data?.file !== null;

    return compact([
      'PolicyAgreement',
      company.data?.tos_agreed && 'Information',
      company.data?.tos_agreed && membershipFormValid && 'Checklist',
      company.data?.tos_agreed && membershipFormValid && checklistFormValid && 'DelegationForm',
      company.data?.tos_agreed &&
        membershipFormValid &&
        checklistFormValid &&
        delegationValid &&
        'Complete',
    ]);
  }

  return [];
};

export const useButtonStyles = makeMuiStyles((theme, common) => ({
  buttons: {
    ...common.flexInline,
    justifyContent: 'center',
    marginTop: 40,
    [theme.breakpoints.down('sm')]: {
      ...common.flexColumnCenter,
      gap: theme.spacing(2),
    },
  },
  button: {
    width: 200,
    margin: '0 20px',
    position: 'relative',
    '&$next:before': {
      content: '""',
      position: 'absolute',
      width: 6,
      height: 6,
      top: 'auto',
      right: 10,
      botton: 'auto',
      border: '6px solid transparent',
      borderLeft: `6px solid ${theme.palette.common.white}`,
    },
    '&$prev:before': {
      content: '""',
      position: 'absolute',
      width: 6,
      height: 6,
      top: 'auto',
      left: 10,
      botton: 'auto',
      border: '6px solid transparent',
      borderRight: `6px solid ${theme.palette.common.white}`,
    },
  },
  prev: {},
  next: {},
}));
